import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, isAuthLoading } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthLoading) {
          return (
            <div className="flex justify-center items-center h-screen">
              <div className="w-10 h-10 border-4 border-dashed rounded-full animate-spin border-gray-600"></div>
              <span className="ml-3 text-gray-600">Checking authentication...</span>
            </div>
          );
        }

        return isAuthenticated ? (
          <Component {...props} /> 
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location} }} />
        )
      }}
    />
  );
};

export default ProtectedRoute